import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from 'src/app/core/services/auth.service';



@Injectable({
    providedIn: 'root'
})
export class PreloginGuard implements CanActivate {
    URL: any;
    signInActive = false;
    constructor(
        private authService: AuthService,
        private router: Router
    ) { }

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        if (this.authService.isLoggednIn()) {
            this.router.navigate(['dashboard']);
            return false;
        }
        return true;
    }
}
